export default class MenuConfig {
    /* 
        ESTRUTURA O OBJETO PARA A SIDEBAR
    
        nome_do_contexto: {
            codigounicotela:  NOME DA ROTA QUE VAI ABRIR DE ACORDO COM O ROUTER;
            icon:       NOME DO ARQUIVO DE ÍCONE PARA SER USADO DE ACORDO COM OS EXISTENTES NA PASTA assets/img/icons, OBRIGATÓRIAMENTE UM SVG;
            nome:    CHAVE DO DICIONÁRIO PARA O TEXTO;
            clickfn:    FUNÇÃO A SER EXECUTADA NO SideBar.vue ANTES DE EXPANDIR O ITEM. UTILIZADO PARA VALIDAR SE PODE ENTRAR NO GEOANÁLISE;
            items:      ARRAY COM OS SUB ITENS DO MENU. SE EXISTIR, OBRIGATORIAMENTE = false E codigounicotela NÃO EXISTE
                [
                    PARA CADA ITEM:
                    {
                        codigounicotela:  NOME DA ROTA QUE VAI ABRIR PELO ROUTER;
                        nome:    CHAVE DO DICIONÁRIO PARA O TEXTO;
                        modulopda:  RESTRIÇÃO DO MÓDULO PDA PARA O ITEM, SE NÃO HOUVER, ELE SERÁ ESCONDIDO;
                        tagnew: Codigo do dia do cadastro da tela, indicando se será mostrado ou não a tag NOVO
                    }
                ]
        }
    */

    loadSidebar(perfil) {
        let items = {};
        if (perfil && perfil.app_moduloList) {
            perfil.app_moduloList.forEach((app_modulo) => {
                let app_modulo_inner = [];
                if (app_modulo.nome != 'admin') {
                    app_modulo.app_moduloList.forEach((app_modulo2) => {
                        // caso esteja configurado para não aparecer no menu
                        if (app_modulo2.visivel == 0) return;

                        // Se a tela estiver configurada para ser exibida e o
                        // usuário tiver permissão de leitura, mostra a tela na sidebar
                        let app_tela_inner = app_modulo2.app_telaList.filter((app_tela) => {
                            return (
                                (perfil.admin && app_tela.visivel) ||
                                (!perfil.admin &&
                                    app_tela.visivel &&
                                    app_tela.perm_perfilacessotelas &&
                                    app_tela.perm_perfilacessotelas.read)
                            );
                        });

                        app_modulo2.expanded = false;
                        app_modulo2.app_tela = app_tela_inner;

                        // Caso o modulo tenha qualquer item, inclui o módulo na sidebar.
                        if (app_modulo2.app_tela.length > 0) {
                            app_modulo_inner.push(app_modulo2);
                        }
                    });
                }
                items[app_modulo.nome] = app_modulo_inner;
            });
        }

        return items;
    }

    loadHeaderDropMenu(perfil) {
        let items = {};

        if (perfil && perfil.app_moduloList) {
            perfil.app_moduloList.forEach((app_modulo) => {
                // Para o dropmenu só carrega quando o modulo for o módulo de admin
                
                if (app_modulo.nome == 'admin') {
                    let app_modulo_inner = [];
                    app_modulo.app_moduloList.forEach((app_modulo2) => {
                        // caso esteja configurado para não aparecer no menu
                        if (app_modulo2.visivel == 0) return;

                        if (app_modulo2.ordem > 0) {
                            // Se a tela estiver configurada para ser exibida e o
                            // usuário tiver permissão de leitura, mostra a tela na sidebar
                            let app_tela_inner = app_modulo2.app_telaList.filter((app_tela) => {
                                return (
                                    (perfil.admin && app_tela.visivel) ||
                                    (!perfil.admin &&
                                        app_tela.visivel &&
                                        app_tela.perm_perfilacessotelas &&
                                        app_tela.perm_perfilacessotelas.read)
                                );
                            });

                            app_modulo2.expanded = false;
                            app_modulo2.app_tela = app_tela_inner;

                            // Caso o modulo tenha qualquer item, inclui o módulo na sidebar,
                            // só é adicionado nesses itens as app_tela_inner que o usuario tem permissão de leitura.
                            if (app_modulo2.app_tela.length > 0) {
                                app_modulo_inner.push(app_modulo2);
                            }
                        }
                    });
                    items[app_modulo.nome] = app_modulo_inner;
                }
            });
        }

        return items;
    }
}
